declare global {
  interface Window {
    newrelic?: any;
  }
}

export let additionalAttributes: { [key: string]: string | boolean | null | undefined } = {};

export const setAdditionalAttributes = (data: { [key: string]: string | boolean | null | undefined }): void => {
  additionalAttributes = { ...additionalAttributes, ...data };

  if (typeof window.newrelic === 'object') {
    Object.keys(data).forEach((key) => {
      window.newrelic.setCustomAttribute(key, data[key]);
    });
  }
};

export function clearAdAttributes(): void {
  setAdditionalAttributes({ ad_id: null, creative_id: null, ad_content_url: null, vast_media_files: null });
}

export function noticeError(msg: string, customAttributes: { [key: string]: any } = {}): void {
  if (typeof window.newrelic !== 'object') return;

  window.newrelic.noticeError(new Error(msg), customAttributes);
}

export function customInteraction(actionName: string, attributes: object = {}): void {
  if (!window.newrelic?.addPageAction) return;

  window.newrelic.addPageAction(actionName, attributes);
}

export const secondsToISODuration = (duration: number): string => {
  const time = Math.round(duration);
  const hours = Math.floor(time / 60 / 60);
  const minutes = Math.floor((time - hours * 60 * 60) / 60);
  const seconds = time - hours * 60 * 60 - minutes * 60;

  let formattedDuration = 'PT';
  if (hours > 0) {
    formattedDuration = `${formattedDuration}${hours}H`;
  }
  if (minutes > 0) {
    formattedDuration = `${formattedDuration}${minutes}M`;
  }
  return `${formattedDuration}${seconds}S`;
};

export const formatTime = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  if (hours > 0) {
    return `${hours}:${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  }
  return `${mins}:${String(secs).padStart(2, '0')}`;
};
